import { useRouterSelector } from '~/hooks/useRouterSelector';
import { getPersonIdFromPath } from '~/utils/PathUtils';

export const useURLPersonIdSelector = () => {
  return useRouterSelector((location) => getPersonIdFromPath(location.pathname));
};
